<ng-template #viewMenuBar>
  <soft-ds-button
    size="sm"
    mode="iconOnly"
    variant="ghost"
    (click)="hostComponent.minimize.set(!hostComponent.minimize())"
  >
    <svg
      *softSlot="'leading'"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.66501 0.665001V12.665M9.33168 8.665L7.33168 6.665L9.33168 4.665M1.99834 0.665001H11.3317C12.0681 0.665001 12.665 1.26195 12.665 1.99833V11.3317C12.665 12.068 12.0681 12.665 11.3317 12.665H1.99834C1.26196 12.665 0.665009 12.068 0.665009 11.3317V1.99833C0.665009 1.26195 1.26196 0.665001 1.99834 0.665001Z"
        stroke="currentColor"
        stroke-width="1.33"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </soft-ds-button>

  <div class="h-full min-h-8 w-px border-l select-none mx-1">&nbsp;</div>

  <soft-ds-button
    size="sm"
    mode="iconOnly"
    [variant]="deliveryNoteRosterService.hideDeletedEvents() ? 'primary' : 'ghost'"
    [attr.aria-pressed]="deliveryNoteRosterService.hideDeletedEvents()"
    (click)="deliveryNoteRosterService.toggleHideDeletedEvents()"
  >
    <soft-icon
      *softSlot="'leading'"
      [name]="
        deliveryNoteRosterService.hideDeletedEvents()
          ? 'fa-regular fa-trash-can-slash'
          : 'fa-regular fa-trash-can'
      "
    />
  </soft-ds-button>

  <div class="h-full min-h-8 w-px border-l select-none mx-1">&nbsp;</div>

  <soft-menu-bar-dropdown
    icon="fa-regular fa-calendar-range"
    [label]="viewTypeLabel()"
    [tooltip]="t('#DN_ROSTER.VIEW_TYPE_LABEL')() + ':\n' + viewTypeLabel()"
    [responsive]="true"
    [hideChevron]="true"
  >
    <soft-menu *softMenuBarDropdownContent class="min-w-40">
      <div class="px-3 py-2 border-b text-sm font-semibold">
        {{ t('#DN_ROSTER.VIEW_TYPE_LABEL')() }}
      </div>
      @for (opt of viewTypeTabs(); track opt.value) {
      <soft-menu-item
        [value]="opt.value"
        [label]="opt.title"
        [selected]="hostComponent.calendarViewType() === opt.value"
        (click)="hostComponent.calendarViewType.set(opt.value)"
      />
      }
    </soft-menu>
  </soft-menu-bar-dropdown>

  <div class="h-full min-h-8 w-px border-l select-none mx-1">&nbsp;</div>

  <soft-menu-bar-pill-switch
    [options]="detailPillOptions()"
    [value]="hostComponent.calendarDetails()"
    (valueChange)="setDetailOption($event)"
    [tooltip]="t('#DN_ROSTER.DETAILS')()"
    [responsive]="true"
  />
</ng-template>

<ng-template #buttons>
  <soft-menu-bar-button
    variant="outline"
    icon="fa-regular fa-arrow-down-from-bracket"
    [label]="t('#DN_ROSTER.IMPORT')()"
    [tooltip]="t('#DN_ROSTER.IMPORT')()"
    [responsive]="true"
    (execute)="import()"
  />
  <div class="w-1 select-none" tabindex="-1">&nbsp;</div>
  <soft-menu-bar-button
    variant="primary"
    icon="fa-regular fa-file-export"
    [label]="t('#DN_ROSTER.EXPORT')()"
    [tooltip]="t('#DN_ROSTER.EXPORT')()"
    [responsive]="true"
    (execute)="export()"
  />
  <div class="w-1 select-none" tabindex="-1">&nbsp;</div>
  <soft-menu-bar-button
    variant="outline"
    icon="fa-regular fa-arrows-rotate"
    [iconOnly]="true"
    [tooltip]="t('#DN_ROSTER.REFRESH')()"
    (execute)="deliveryNoteRosterService.refreshEvents()"
  />
</ng-template>

<ng-template #selectionLeadingMenuBar>
  <soft-menu-bar-button
    icon="fa-regular fa-trash-alt"
    [label]="t('#DN_ROSTER.DELETE')()"
    [tooltip]="t('#DN_ROSTER.DELETE')()"
    variant="danger"
    [responsive]="true"
    [disabled]="isDeleteButtonDisabled()"
    (execute)="deleteSelected()"
  />
  <div class="w-1 select-none" tabindex="-1">&nbsp;</div>
  <soft-menu-bar-button
    variant="outline"
    icon="fa-regular fa-envelope"
    [label]="t('#DN_ROSTER.MAIL')()+' '+mailCount()"
    [tooltip]="!isMailButtonDisabled() ? t('#DN_ROSTER.MAIL_TOOLTIP')() : t('#DN_ROSTER.MAIL_TOOLTIP_DISABLED')()"
    [responsive]="true"
    [disabled]="isMailButtonDisabled()"
    (execute)="sendMail()"
  />
</ng-template>

<ng-template #selectionTrailingMenuBar>
  <span class="text-xs text-foreground/70 px-1">
    <span class="font-semibold">{{ selectedCount() }}</span>
    {{ t('#DN_ROSTER.SELECTED')() }}
  </span>
</ng-template>

<ng-template #contextMenu>
  <soft-ds-context-menu>
    @for (action of deliveryNoteRosterService.contextMenuActions(); track action.action) {
    <soft-ds-context-menu-item
      [icon]="action.icon"
      [label]="action.label"
      [variant]="action.danger ? 'danger' : 'default'"
      (triggered)="deliveryNoteRosterService.handleContextMenuAction(action.action)"
    />
    }
  </soft-ds-context-menu>
</ng-template>
